export const DIGIT_TYPES = {
  digits: { 
    label: '数字', 
    value: 'digits',
    description: '按数字读法读出，如"一二三"'
  },
  number: { 
    label: '数值', 
    value: 'number',
    description: '按数值读法读出，如"一百二十三"'
  },
  date: { 
    label: '日期', 
    value: 'date',
    description: '按日期格式读出，如"二零二四年四月十五日"'
  },
  telephone: { 
    label: '电话号码', 
    value: 'telephone',
    description: '按电话号码读出，如"一二三四五"'
  }
}

export const PAUSE_OPTIONS = [
  { label: '0.2s', value: '200ms' },
  { label: '0.5s', value: '500ms' },
  { label: '1s', value: '1000ms' }
]